import React from 'react'
import Plot from 'react-plotly.js';

const Boxplot = ({plot, data,name,plotname}) => {
  
  var boxplot1 = {
    y: data,
    type: plot,
    name:name,
    marker: {
      color: 'rgb(8,81,156)',
      outliercolor: 'rgba(219, 64, 82, 0.6)',
      line: {
        outliercolor: 'rgba(219, 64, 82, 1.0)',
        outlierwidth: 2
      }
    },
    boxpoints: 'suspectedoutliers'
  };

  return (
    <div id='boxplot'>
      <Plot 
      data = {[
        boxplot1
        
      ]}
      layout={{width:600,height:400,title:plotname}}
      />
    </div>
  )
}

export default Boxplot
